import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../components/Card/Card';
import { useGetBooksQuery } from '../../features/apiSlice/apiSlice';
import { setShowFeatured } from '../../features/filter/filterSlice';

const Home = () => {
    const { data, isLoading, isError } = useGetBooksQuery()
    const { text, showFeatured } = useSelector(state => state.filter)
    const dispatch = useDispatch()
    let content = null;

    if (isLoading) {
        content = (
            <>
                <div className='text-center'>Loading...</div>
            </>
        );
    }

    if (!isLoading && isError) {
        content = <div className='text-center'>Something is wrong</div>
    }

    if (!isLoading && !isError && data?.length === 0) {
        content = <div className='text-center'>Books not found</div>
    }

    if (!isLoading && !isError && data?.length > 0) {
        let filterData = [...data]
        if (showFeatured) {
            filterData = data.filter(single => single.featured)
        }
        if (text) {
            filterData = filterData.filter(single => single.name.toLowerCase().includes(text.toLowerCase()))
        }
        content = filterData.map((single) => <Card key={single.id} {...single} />);
    }

    return (
        <main className="py-12 px-6 2xl:px-6 container">
            <div className="order-2 xl:-order-1">
                <div className="flex items-center justify-between mb-12">
                    <h4 className="mt-2 text-xl font-bold">Book List</h4>

                    <div className="flex items-center space-x-4">
                        <button onClick={() => {
                            dispatch(setShowFeatured(false))
                        }} className={`lws-filter-btn ${!showFeatured && "active-filter"}`}>All</button>
                        <button
                            onClick={() => {
                                dispatch(setShowFeatured(true))
                            }}
                            className={`lws-filter-btn ${showFeatured && "active-filter"}`}

                        >Featured</button>

                    </div>
                </div>
                <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
                    {/* <!-- Card 1 --> */}
                    {content}
                </div>
            </div>
        </main>
    );
};

export default Home;